// Converts "FooBarBaz" into "Foo Bar Baz"
function splitStringIntoWords(str: string): string {
    if (!str) {
        return str;
    }
    return str.replace(/([a-z\d])([A-Z\d])/g, (m, v1, v2) => v1 + " " + (v2.length === 1 ? v2.toLowerCase() : v2));
}

export default splitStringIntoWords;
